export interface SalesInvoiceItemAddRemove {
  salesInvoiceHeaderId: string;
  salesInvoiceItemId: string;
}
